// Common file utilities for names, extensions, and type checks

export const getFileExtension = (fileName: string): string => {
  if (!fileName) return '';
  const dot = fileName.lastIndexOf('.');
  return dot >= 0 ? fileName.substring(dot + 1) : '';
};

export const truncateFileName = (name: string, max: number = 20): string => {
  if (!name) return '';
  if (name.length <= max) return name;
  return `${name.substring(0, max)}...`;
};

export const isImageFileName = (pathOrName?: string | null): boolean => {
  if (!pathOrName) return false;
  return /\.(jpg|jpeg|png|gif|webp)$/i.test(pathOrName);
};

export type FileKind = 'image' | 'pdf' | 'other';

export const getFileKind = (file: { mimeType?: string | null; fileUrl: string }): FileKind => {
  const mt = file.mimeType?.toLowerCase();
  if (mt?.startsWith('image/')) return 'image';
  if (mt === 'application/pdf') return 'pdf';

  const ext = file.fileUrl.split('?')[0].split('.').pop()?.toLowerCase();
  if (['jpg', 'jpeg', 'png', 'webp', 'gif', 'heic', 'heif', 'bmp'].includes(ext ?? '')) return 'image';
  if (ext === 'pdf') return 'pdf';

  return 'other';
};
